import { ReactElement } from 'react'
import { salesReportIcons } from '../icons'
import { Box, Chevron, Field, Label, Select } from './styles'

export interface SelectOption {
  value: string
  label: string
}

interface SelectFieldProps {
  id: string
  label: string
  value: string
  options: SelectOption[]
  onChange: (value: string) => void
  placeholder?: string
  inline?: boolean
  dense?: boolean
  width?: string
  disabled?: boolean
}

export function SelectField({
  id,
  label,
  value,
  options,
  onChange,
  placeholder,
  inline = false,
  dense = false,
  width,
  disabled = false,
}: SelectFieldProps): ReactElement {
  return (
    <Field $inline={inline}>
      <Label htmlFor={id} $inline={inline} $dense={dense}>
        {label}
      </Label>
      <Box $width={width}>
        <Select
          id={id}
          value={value}
          disabled={disabled}
          $placeholder={placeholder != null && value === ''}
          onChange={(event) => onChange(event.target.value)}
        >
          {placeholder != null && <option value="">{placeholder}</option>}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
        <Chevron src={salesReportIcons.chevronDown} alt="" width={16} height={16} aria-hidden="true" />
      </Box>
    </Field>
  )
}
